import { useModoConsultaEvaluacion } from '../../../../hooks/useModoConsultaEvaluacion';
import React, { useState, useContext } from 'react';
import { AppContext } from '../../../../Context';
import { collection, addDoc } from "firebase/firestore";
import { db } from '../../../../firebase/firebase';
import { Form, Button, Container, Card } from 'react-bootstrap';
import Swal from 'sweetalert2';

const M11_Ejercicio7 = ({ cerrarModal }) => {
    const { currentUser } = useContext(AppContext);
    const modoConsulta = useModoConsultaEvaluacion();
    
    const datosABuscar = [
        "entre el 15 y 20% de la energía",
        "1000 vatios de energía",
        "calculadoras y relojes",
        "su combustible será gratuito",
        "Queen’s University de Ontario",
        "Velocidad promedio de 75 km/h",
        "generando electricidad",
        "Autos impulsados con energía solar",
        "células fotovoltaicas de silicio",
        "7042 kilómetros"
    ];

    const respuestasCorrectas = {
        "entre el 15 y 20% de la energía": "podemos capturar entre el 15 y 20% de la energía radiada por el sol",
        "1000 vatios de energía": "un metro cuadrado recibe 1000 vatios de energía",
        "calculadoras y relojes": "Al principio fueron sólo calculadoras y relojes",
        "su combustible será gratuito": "su combustible será gratuito",
        "Queen’s University de Ontario": "Queen’s University de Ontario en Canadá",
        "Velocidad promedio de 75 km/h": "a una velocidad promedio de 75 km/h",
        "generando electricidad": "generando electricidad",
        "Autos impulsados con energía solar": "autos impulsados con energía solar",
        "células fotovoltaicas de silicio": "células fotovoltaicas de silicio",
        "7042 kilómetros": "recorrer 7042 kilómetros"
    };

    const [respuestas, setRespuestas] = useState(
        datosABuscar.reduce((acc, dato, index) => {
            acc[`dato_${index}`] = { dato, contexto: '' };
            return acc;
        }, {})
    );

    const handleChange = (index, value) => {
        setRespuestas(prev => ({
            ...prev,
            [`dato_${index}`]: {
                ...prev[`dato_${index}`],
                contexto: value
            }
        }));
    };

    const calcularPuntaje = () => {
        let puntaje = 0;
        datosABuscar.forEach((dato, index) => {
            const respuestaUsuario = respuestas[`dato_${index}`].contexto.toLowerCase().trim();
            const respuestaCorrecta = respuestasCorrectas[dato].toLowerCase().trim();
            
            // Si la respuesta del usuario está incluida en la correcta o viceversa, damos puntos
            if (respuestaUsuario && (respuestaCorrecta.includes(respuestaUsuario) || respuestaUsuario.includes(respuestaCorrecta))) {
                puntaje += 2; // 1 punto por encontrar + 1 punto por citar
            }
        });
        return puntaje;
    };

    const enviarResultados = async () => {
        if (modoConsulta) { cerrarModal?.(); return; }

        const todasRespondidas = Object.values(respuestas).every(r => r.contexto.trim() !== '');
        
        if (!todasRespondidas) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Por favor, completa el contexto de todos los datos antes de enviar.',
                confirmButtonColor: '#3085d6'
            });
            return;
        }

        const puntajeFinal = calcularPuntaje();

        try {
            await addDoc(collection(db, "evaluaciones"), {
                userId: currentUser.uid,
                nombre: "Ejercicio 7 - Ejercicio de rastreo",
                nivel: "Avanzado",
                modulo: "11",
                createdAt: new Date(),
                tipo: "Rastreo",
                respuestas: respuestas,
                puntaje: puntajeFinal,
                puntajeMaximo: 20
            });
            Swal.fire({
                title: '¡Evaluación Enviada!',
                text: `Resultados enviados con éxito. Tu puntaje estimado es ${puntajeFinal}/20.`,
                icon: 'success',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Excelente'
            }).then((result) => {
                if (result.isConfirmed) {
                    cerrarModal();
                }
            });
        } catch (error) {
            console.error("Error al enviar las respuestas: ", error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al enviar las respuestas.',
                confirmButtonColor: '#3085d6'
            });
        }
    };

    return (
        <Container>
            <Card className="mb-4 shadow-sm">
                <Card.Body>
                    <Card.Title>Lectura Base: ENERGÍA SOLAR</Card.Title>
                    <Card.Text style={{ textAlign: 'justify', lineHeight: '1.6' }}>
                        El hombre, desde tiempos muy remotos, se ha preocupado por encontrar nuevas fuentes de energía; más cercanas, más sencillas de obtener y más baratas. En la actualidad, se siguen buscando, pero ha aumentado una condición: estas deben ser más amigables con el ambiente. Así, los hombres de ciencia han dirigido su mirada al sol.<br/><br/>
                        El desarrollo de autos impulsados con energía solar no se debe tan sólo a aquello de la contaminación o de la alarmante forma en que estamos deteriorando el medio ambiente, tiene mucho que ver con la economía. En un día soleado, una superficie de un metro cuadrado recibe 1000 vatios de energía; energía que no cuesta mucho y que no tiene repercusión alguna en la naturaleza o en el ser humano.<br/><br/>
                        La carrera de la energía solar empezó hace unas dos décadas. Al principio fueron sólo calculadoras y relojes, pero ahora podemos encontrar autos, satélites e incluso casas alimentándose con energía proveniente del sol. La conversión de los rayos del sol en energía es algo compleja, para hacerla es necesario utilizar unas células fotovoltaicas de silicio o algún otro semiconductor para que, tras recibir los rayos del sol, se exciten sus electrones con los fotones contenidos en la luz y de esta manera produzcan electricidad.<br/><br/>
                        Suena fácil, pero en los módulos fotovoltaicos se lleva a cabo una reacción química interesante. Al ser golpeadas las celdas por los rayos del sol, al menos un electrón del semiconductor quedará libre; estas celdas tienen campos eléctricos así que el electrón liberado fluirá en una dirección determinada generando electricidad. En la parte superior e inferior de las celdas hay contactos metálicos que recibirán esta energía y la conducirán fuera de la celda.<br/><br/>
                        Utilizando silicio en las celdas fotovoltaicas podemos capturar entre el 15 y 20% de la energía radiada por el sol. Esto es porque los fotones que tienen una longitud de onda muy baja cruzarán las celdas como si fueran transparentes mientras que los que tienen una longitud de onda alta no liberan ningún electrón. Además, al reflejar hace que muchos de los fotones reboten y se pierdan. Mientras no se encuentre un semiconductor que tenga las características del silicio no se podrá mejorar mucho el manejo de la energía solar.<br/><br/>
                        Este principio es el que permite que las calculadoras funcionen con cualquier luz, aun sin tener pila, y es también el que permitió a un equipo de estudiantes de la Queen’s University de Ontario en Canadá recorrer 7042 kilómetros en un auto alimentado solamente con energía solar a una velocidad promedio de 75 km/h; nada mal si tomamos en cuenta que no gastaron ni un litro de gasolina.<br/><br/>
                        En la actualidad todos los autos solares son ligeros, incómodos, de una sola plaza y excesivamente caros; pero todos son pruebas. No falta mucho para que se mejoren las celdas fotovoltaicas y permitan que todos los autos sean solares. Tendrán &lt;&lt;cero emisiones&gt;&gt; y su combustible será gratuito.
                    </Card.Text>
                </Card.Body>
            </Card>

            <Form>
                <h5 className="mb-3">Aplicando la técnica de rastreo, ubica los siguientes datos y escribe el fragmento exacto donde lo encontraste:</h5>
                {datosABuscar.map((dato, index) => (
                    <Form.Group className="mb-3" key={index}>
                        <Form.Label className="fw-bold">Dato: "{dato}"</Form.Label>
                        <div className="text-muted small mb-1">Escribe el fragmento exacto...</div>
                        <Form.Control 
                            type="text" 
                            value={respuestas[`dato_${index}`].contexto}
                            onChange={(e) => handleChange(index, e.target.value)}
                        />
                    </Form.Group>
                ))}

                <div className="text-center mt-4 mb-4">
                    <Button variant="primary" size="lg" onClick={enviarResultados}>
                        Enviar Resultados
                    </Button>
                </div>
            </Form>
        </Container>
    );
};

export default M11_Ejercicio7;
